  import React from "react";
// import icons from '../../../assets/icon-all';
import { NavLink, Link } from "react-router-dom";
import Logo from '../../../synaccess_white.svg'
import { clearBrowserAuthSession, redirectToLogin } from '../../../utils/sessionLogout';

import pages from "../../../pages/routes";

const hamburger = (
  <svg
    style={{ weight: "38px", height: "38px" }}
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

const getStoredStylingLogo = () => {
  try {
    const styling = localStorage.getItem("styling");
    if (!styling) {
      return "";
    }

    const stylingJson = JSON.parse(styling);
    return stylingJson?.logoUrl || "";
  } catch (_error) {
    return "";
  }
};

const getUserStylingLogo = (user) => user?.enterprise?.ui_theme?.logoUrl || "";

export default class SideHeader extends React.Component {
  state = {
    // active: false,
    logo: Logo,
    darkMode: document.body.classList.contains("dark-mode"),
  };

  getResolvedLogo = (props = this.props) =>
    getUserStylingLogo(props.user) || getStoredStylingLogo() || Logo;

  componentDidMount() {
    this.setState({
      logo: this.getResolvedLogo(),
    });

    const darkMode = localStorage.getItem("darkMode") === "true";
    document.body.classList.toggle("dark-mode", darkMode);
    this.setState({ darkMode });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user === this.props.user) {
      return;
    }

    const logo = this.getResolvedLogo();
    if (logo !== this.state.logo) {
      this.setState({ logo });
    }
  }

  toggleDarkMode = () => {
    const darkMode = !this.state.darkMode;
    document.body.classList.toggle("dark-mode", darkMode);
    localStorage.setItem("darkMode", String(darkMode));
    this.setState({ darkMode });
  };

  render() {
    // const { active } = this.state;
    const {
      // device,
      // lastUpdated,
      // wsActive,
      changeAppState,
      miniModeActive,
      mobileSideNavActive,
      // banks,
      // user = {
      //   role: {
      //     permissions: {}
      //   }
      // },
      // conf
      user,
      onOpenGlobalSearch,
    } = this.props;
    const items = pages(user, this.props.resources)
      .filter((p) => !p.unlisted)
      .filter((p) => !p.disabled)
      .filter((p) => !p.hideFromHeader)
      .map((page) => ({
        name: page.headerTitle,
        link: page.basePath,
        icon: page.headerIcon,
      }));
    return (
      <div
        className={`side-nav-wrapper${mobileSideNavActive ? " active" : " "}${
          miniModeActive ? " mini" : ""
        }`}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: "8px",
              paddingRight: "8px",
              alignItems: "flex-start",
              // marginBottom: '-20px',
              cursor: "pointer",
              zIndex: "999",
              position: "relative",
              // width: "30px"
            }}
            onClick={() => {
              changeAppState({
                miniModeActive: !miniModeActive,
                mobileSideNavActive: !mobileSideNavActive,
              });
            }}
          >
            {hamburger}
          </div>
          <Link to="/">
            <header className={`App-header ${miniModeActive ? "mini" : ""}`}>
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fill: "white",
                }}
              >
                {logo}
              </div>
              <div className="App-title">Synaccess Cloud</div> */}
              <img
                alt="logo"
                src={this.state.logo}
              />
            </header>
          </Link>

          <div
            className={`side-nav-container ${miniModeActive ? "mini" : ""}`}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <button
              type="button"
              className={`side-nav-item side-nav-search-trigger ${
                miniModeActive ? "mini" : ""
              }`}
              onClick={onOpenGlobalSearch}
              title="Search"
              aria-label="Search"
            >
              <i className="material-icons side-nav-item-icon">manage_search</i>
              <div className="side-nav-item-label">Search</div>
            </button>
            {items.map((item) => {
              return (
                <NavLink
                  to={`${item.link}`}
                  activeClassName={`side-nav-item active ${
                    miniModeActive ? "mini" : ""
                  }`}
                  className={`side-nav-item ${miniModeActive ? "mini" : ""}`}
                  key={item.name}
                  onClick={() => {}}
                >
                  <i className="material-icons side-nav-item-icon">{item.icon}</i>
                  <div className="side-nav-item-label">{item.name}</div>
                </NavLink>
              );
            })}
          </div>
        </div>
        <div style={{ paddingBottom: "40px"}}>

        <div
            className={`side-nav-container ${miniModeActive ? "mini" : ""}`}
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >

          {!miniModeActive ? (
            <div className="side-nav-user-info">
              <div className="side-nav-user-info-label">Logged in as:</div>
              <div className="side-nav-user-info-email">{user?.email_id}</div>
            </div>
          ) : null}
          <button
            type="button"
            className={`side-nav-theme-toggle ${
              this.state.darkMode ? "active" : ""
            } ${miniModeActive ? "mini" : ""}`}
            aria-checked={this.state.darkMode}
            aria-label={
              this.state.darkMode ? "Switch to light mode" : "Switch to dark mode"
            }
            role="switch"
            title={this.state.darkMode ? "Switch to light mode" : "Switch to dark mode"}
            onClick={this.toggleDarkMode}
          >
            <div className="side-nav-theme-toggle__content">
              <i className="material-icons side-nav-item-icon" aria-hidden="true">
                {this.state.darkMode ? "dark_mode" : "light_mode"}
              </i>
              <div className="side-nav-item-label">Dark Mode</div>
            </div>
            <span className="side-nav-theme-toggle__track" aria-hidden="true">
              <span className="side-nav-theme-toggle__thumb" />
            </span>
          </button>
          <NavLink
            to="/users"
            className={`side-nav-item ${miniModeActive ? "mini" : ""}`}
            style={{marginBottom: "40px" }}
          >
            <i className="material-icons side-nav-item-icon">account_circle</i>
            <div className="side-nav-item-label">Account</div>
          </NavLink>
          <a
            href="/logout"
            className={`side-nav-item ${miniModeActive ? "mini" : ""}`}
            onClick={(event) => {
              event.preventDefault();
              clearBrowserAuthSession();
              redirectToLogin();
            }}
          >
            <i className="material-icons side-nav-item-icon">logout</i>
            <div className="side-nav-item-label">Logout</div>
          </a>
          </div>
        </div>
      </div>
    );
  }
}
// const SideHeaderItems = ({items}) => {
//   return (
//     items.map(item => {
//       if (item.disabled) return null;
//       const ConditionalElement = item.link ? Link : "div";

//       return (
//         <div
//           key={item.label}
//           style={{
//             paddingBottom: '20px',
//             paddingLeft: '15px',
//             color: 'white'
//           }}
//         >
//           <div
//             style={{
//               paddingBottom: '3px',
//               fontSize: '75%',
//             }}
//           >
//             {item.label}:
//           </div>
//           <ConditionalElement
//             style={{
//               fontWeight: '500',
//               color: item.color || "white",
//               textDecoration: item.link ? "underline" : ""
//             }}
//             to={item.link}
//           >
//             {item.value}
//           </ConditionalElement>
//         </div>
//       )
//     })
//   )
// }
